import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'date-target-indicator',
    templateUrl: './date-target-indicator.component.html',
    styleUrls: ['./date-target-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateTargetIndicatorComponent {
  @Input() target: boolean;
}
